<template>
  <div class="form-date">
    <input
      type="date"
      v-model.lazy="date"
      placeholder="選択してください"
      :id="name"
      :name="name"
      :disabled="disabled"
      :class="['datepicker',{'is-error':error}]"
      :max="max"
    />
    <label
      :for="name"
      class="label"
      :class="{'is-disabled':disabled}"
    ><img src="@/assets/images/icon_calendar.png" alt=""></label>
  </div>
</template>

<script>
import dayjs from 'dayjs';

export default {
  name: 'form-date',
  props: {
    modelValue: { type: [Date, String], require: true },
    name: { type: String, require: true },
    max: { type: String, require: false, default: '9999-12-31' },
    disabled: { type: Boolean, require: false, 'default':false },
    error: { type: Boolean, require: false, 'default':false }
  },
  emits: ['update:modelValue'],
  computed: {
    date: {
      get() {
        return this.getFormat(this.modelValue)
      },
      set(newValue) {
        this.$emit('update:modelValue', this.setFormat(newValue))
      }
    }
  },
  methods: {
    setFormat(value) {
      return value ? dayjs(value).format('YYYY/MM/DD') : '';
    },
    getFormat(value) {
      return value ? dayjs(value).format('YYYY-MM-DD') : '';
    }
  }
}

</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/variables";
@import "@/assets/stylesheets/mixins";
.form-date {
  display: flex;
  align-items: center;
  @include mq-down(sm) {
    width: 100%;
    > .vdp-datepicker {
      width: 100%;
    }
  }
  > .label {
    cursor: pointer;
    margin-left: 10px;
    &.is-disabled {
      cursor: not-allowed;
      opacity: .5;
    }
    > img {
      width: 36px;
    }
  }
}
.datepicker {
  display: block;
  position: relative;
  padding: 0 10px;
  width: 100%;
  height: 40px;
  appearance: none;
  background-color: $white-01;
  border-radius: 5px;
  border: 1px solid $gray-line;
  font-size: 14px;
  line-height: 38px;
  color: inherit;
  &::placeholder {
    color: inherit;
  }
  @include mq-up(sm) {
    width: 200px;
  }
  &:disabled {
		background-color: $gray-line;
  }
  &.is-error {
    background-color: $red-bg;
  }
  &::-webkit-calendar-picker-indicator {
    opacity: 0;
    width: 36px;
    height: 38px;
    position: absolute;
    top: -1px;
    right: -47px;
    cursor: pointer;
  }
  &::-webkit-date-and-time-value {
    text-align: left;
  }
}
</style>
